const DESIGNERS_LIST_PAGE = 'DesignerList';

export { DESIGNERS_LIST_PAGE };
